import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import "./ContactForm.css"
import { useState } from 'react';
import toast from 'react-hot-toast';


const ContactForm = () => {
  const form = useRef();
  const defaultFormData={
    name: '',
    email: '',
    message: '',
  };
  const [formData, setFormData] = useState(defaultFormData);

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.promise(
      emailjs
      .sendForm(process.env.REACT_APP_EmailServiceId, process.env.REACT_APP_EmailTemplateId, form.current, {
        publicKey: process.env.REACT_APP_EmailJsPublicKey,}),
       {
         loading: 'Sending...',
         success: <b>Message Sent!</b>,
         error: <b>FAILED...</b>,
       }
     );

    setFormData(defaultFormData);



    // emailjs
    //   .sendForm(process.env.REACT_APP_EmailServiceId, process.env.REACT_APP_EmailTemplateId, form.current, {
    //     publicKey: process.env.REACT_APP_EmailJsPublicKey,
    //   })
    //   .then(
    //     () => {
    //       // console.log('SUCCESS!');
    //       toast.success('Message Sent!');
    //     },
    //     (error) => {
    //       console.log('FAILED...', error.text);
    //       toast.error('FAILED...');
    //     },
    //   );
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
<form name="contact" onSubmit={handleSubmit} ref={form}
// method="POST" data-netlify="true"
>
    <h3 className={"text"}>Contact <span className='different'>Form</span> </h3>
    
  <p>
    <label><span className='different' >Name</span> <input type="text" placeholder='Your Name...' name="name" value={formData.name} onChange={handleChange} required /></label>
  </p>
  <p>
    <label><span className='different' >Email</span> <input type="email" placeholder='Your Email...' name="email" value={formData.email} onChange={handleChange} required /></label>
  </p>
  <p>
    <label><span className='different'>Message</span> <textarea name="message" className={"textArea"} placeholder='Type your message here...' value={formData.message} onChange={handleChange} required /></label>
  </p>
  <div className='buttonContainer'>
    <button type="submit" className="btns onbt submitButton">Submit</button>
  </div>
</form>
  )
}

export default ContactForm